import { render, staticRenderFns } from "./screenExternal.vue?vue&type=template&id=1f128b2e&scoped=true&"
import script from "./screenExternal.vue?vue&type=script&lang=js&"
export * from "./screenExternal.vue?vue&type=script&lang=js&"
import style0 from "./screenExternal.vue?vue&type=style&index=0&id=1f128b2e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f128b2e",
  null
  
)

export default component.exports